import React from 'react';
import { PanelConfig } from './PanelConfig';
import { PanelProducts } from './PanelProducts';
import { PanelResults } from './PanelResults';

export const MainGenerator: React.FC = () => {
  return (
    <main style={{ display: 'grid', gridTemplateColumns: 'var(--panel-a) var(--panel-b) 1fr', minHeight: 0, overflow: 'hidden', flex: 1 }}>
      <PanelConfig />
      <PanelProducts />
      <PanelResults />
    </main>
  );
};
